import adsConfig from '../data/ads.json'
import type { AdItem, AdSlotConfig, AdsConfig } from '../types'

const config = adsConfig as AdsConfig

export function getAdSlot(slotId: string): AdSlotConfig | null {
  const slot = config.slots[slotId]
  if (!slot || !slot.enabled) return null
  return slot
}

/**
 * 取某广告位下启用的广告，按 weight 降序，截断 maxItems。
 * 可选 kind 过滤（如仅开户）。
 */
export function getAdsForSlot(
  slotId: string,
  options?: { kind?: AdItem['kind'] | AdItem['kind'][] },
): { slot: AdSlotConfig; items: AdItem[] } | null {
  const slot = getAdSlot(slotId)
  if (!slot) return null

  const kinds = options?.kind
    ? Array.isArray(options.kind)
      ? options.kind
      : [options.kind]
    : null

  const items = config.items
    .filter((ad) => ad.enabled)
    .filter((ad) => ad.slots.includes(slotId))
    .filter((ad) => (kinds ? kinds.includes(ad.kind) : true))
    .sort((a, b) => b.weight - a.weight)
    .slice(0, Math.max(0, slot.maxItems))

  if (items.length === 0) return null
  return { slot, items }
}
